var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.896,
    height: 19.896,
    viewBox: "0 0 19.896 19.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.948,11.191a5.6,5.6,0,1,0-5.6-5.6A5.6,5.6,0,0,0,9.948,11.191Zm4.974,1.243H12.781a6.764,6.764,0,0,1-5.666,0H4.974A4.974,4.974,0,0,0,0,17.409v.622A1.866,1.866,0,0,0,1.865,19.9H18.03A1.866,1.866,0,0,0,19.9,18.03v-.622A4.974,4.974,0,0,0,14.922,12.435Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserAlt);
export default __webpack_public_path__ + "static/media/Icon-user-alt.0b7ebd1c9e36376bcd96d0904b9f4185.svg";
export { ForwardRef as ReactComponent };